export default __webpack_public_path__ + "0529071f6e2c4c6268d6d19abee40751.png";